module.exports = __webpack_public_path__ + "assets/adobe-experience-platform-identity-service.afbde1db.svg";